<template>
	<div>
		<div class="d-flex align-items-center mb-3">
			<div>
				<h1 class="page-header mb-0"><i class="fas fa-users"></i> Felhasználók</h1>
			</div>
			<div class="ms-auto">
				<button class="btn btn-success btn-rounded px-4 rounded-pill" v-b-modal.addUserModal><i class="fa fa-plus fa-lg me-2 ms-n2 text-success-900"></i> Új felhasználó</button>
			</div>
		</div>
		<div class="row">
			<div class="col-12">
				<panel title="Felhasználók">
					<Loading v-if="!users || !roles" title="Felhasználók betöltése"></Loading>
					<NoRecords v-else-if="users.length == 0" main_icon="fas fa-users" value="false" title="Nincsenek felhasználók" subtitle="adjon hozzá újat"></NoRecords>
					<vue-good-table v-else
						:columns="columns" 
						:rows="users" 
						:lineNumbers="true"
						:search-options="{ enabled: false, placeholder: 'Keresés...' }" 
						:pagination-options="{
							enabled: true, 
							position: 'bottom',

						}"
					>
						<template slot="table-row" slot-scope="props">
							<span v-if="props.column.field == 'actions'">
								<router-link v-if="props.row.role_id == 10" :to="'/base-data/users/'+props.row.id+'/bookings'" class="btn btn-success btn-xs mx-1" title="foglalások"><i class="fa fa-book"></i></router-link>
								<router-link :to="'/base-data/users/'+props.row.id+'/edit'" class="btn btn-primary btn-xs mx-1" title="edit"><i class="fa fa-edit"></i></router-link>
								<button @click="confirmDelete(props.row.id)" class="btn btn-danger btn-xs mx-1" title="delete"><i class="fa fa-trash"></i></button>
							</span>
							<span v-else-if="props.column.field == 'role_id'">
									{{ roles.find(r => r.id == props.row.role_id).name }}
							</span>
							<span v-else-if="props.column.field == 'is_active'">
								<div class="form-check form-switch">
									<input class="form-check-input" type="checkbox" :id="'checkbox_active'+props.row.id" v-model="props.row.is_active" @change="toggleActive(props.row.id)"/>
									<label class="form-check-label" :for="'checkbox_active'+props.row.id">{{props.row.is_active == 1 ? 'aktív' : 'inaktív'}}</label>
								</div>
							</span>
							<span v-else>
								{{props.formattedRow[props.column.field]}}
							</span>
						</template>
					</vue-good-table>
				</panel>
			</div>
		</div>
		<b-modal id="addUserModal" cancel-variant="default" @cancel="closeAddModal()" @ok="addUser" ok-title="Létrehozás" cancel-title="Mégse" :ok-disabled="loading" @shown="$refs.add_user_modal_name_input.focus()">
			<template slot="modal-header">
				<h4 class="modal-title">Új felhasználó</h4>
				<a class="btn-close" @click="closeAddModal()"></a>
			</template>
			<Loading v-if="!users || !roles"></Loading>
			<form @submit.prevent="addUser()" ref="user_modal_form" v-else-if="loading == false">
				<div class="form-group">
					<label class="form-label">Név:</label>
					<input ref="add_user_modal_name_input" class="form-control" type="text" v-model="user.name" required :class="{'is-invalid' : errors.name}">
					<div class="invalid-feedback d-block" v-if="errors.name">
							{{ errors.name[0] }}
					</div>
				</div>
				<div class="form-group mt-2">
					<label class="form-label">Email:</label>
					<input class="form-control" type="email" v-model="user.email" required :class="{'is-invalid' : errors.email}">
					<div class="invalid-feedback d-block" v-if="errors.email">
							{{ errors.email[0] }}
					</div>
				</div>
				<div class="form-group mt-2">
					<label class="form-label">Jogkör:</label>
					<v-select v-model="user.role_id" :options="roles" :reduce="(option) => option.id" label="name">
						<template #search="{attributes, events}">
							<input
								class="vs__search"
								:required="!user.role_id"
								v-bind="attributes"
								v-on="events"
								:placeholder="!user.role_id ? 'Válassz Jogkört!' : ''"
							/>
						</template>
					</v-select>
				</div>
				<div class="form-group mt-2" v-if="user.role_id == 2">
					<label class="form-label">Vendégház:</label>
					<Loading mini v-if="!guesthouses"></Loading>
					<v-select v-else v-model="user.guesthouse_id" :options="guesthouses" :reduce="(option) => option.id" label="name">
						<template #search="{attributes, events}">
							<input
								class="vs__search"
								:required="!user.guesthouse_id"
								v-bind="attributes"
								v-on="events"
								:placeholder="!user.guesthouse_id ? 'Válassz Vendégházat!' : ''"
							/>
						</template>
					</v-select>
				</div>
				<button type="submit" class="d-none"></button>
			</form>
			<Loading v-if="loading == true" title="Létrehozás"></Loading>
		</b-modal>
	</div> 
</template>

<script>
	import User from "../../apis/User";
	import Guesthouse from "../../apis/Guesthouse";
	import Confirmation from "../../apis/Confirmation"; 

	export default {
		data() {
			return {
				columns: [
					{
						label: 'Név',
						field: 'name',
						filterOptions : {
							enabled:true,
							placeholder: 'Keresés',
						}
					},
					{
						label: 'Email',
						field: 'email',
						filterOptions : {
							enabled:true,
							placeholder: 'Keresés',
						}
					},
					{
						label: 'Jogkör',
						field: 'role_id',
						filterOptions : {
							enabled:true,
							placeholder: 'Minden jogkör',
							filterDropdownItems: JSON.parse(localStorage.getItem('constants')).roles.map(r => ({
								value:r.id,
								text:r.name
							}))
						},
					},
					{
						label: 'Aktív',
						field: 'is_active',
						filterOptions : {
							enabled:true,
							placeholder: 'Mind',
							filterDropdownItems:[
								{ value:1,text:'aktív' },
								{ value:0,text:'inaktív' },
							]
						},
					},
					{
						label: 'Műveletek',
						field: 'actions',
						width: '15%',
						sortable: false,
						thClass: 'text-end',
						tdClass: 'text-end',
					}  
				],
				users: false,
				user: {},
				loading: false,
				roles: false,
				guesthouses: false,
				errors:[]
			}
		},
		created() {
			User.index()
			.then(response => {
				this.users = response.data;
			});
			Guesthouse.index()
			.then(response => {
				this.guesthouses = response.data;
			});
			
			this.roles = JSON.parse(localStorage.getItem('constants')).roles;
		},
		watch:{
			'user.role_id':function(){
				delete this.user.guesthouse_id
			}
		},
		methods: {
			toggleActive(id){
				User.toggleActive(id)
			},
			closeAddModal(){
				this.user = {};
				this.errors = [];
				this.$bvModal.hide('addUserModal')
			},
			addUser(bvModalEvt){
				this.loading = true;
				if(bvModalEvt){ //ok gombra van csak event
					bvModalEvt.preventDefault();
				}
				this.errors = [];
				User.add(this.user)
				.then(response => {
					this.users.push(response.data);
					this.closeAddModal();
				}).catch(error => {
					if(error.response.data.errors){
						this.errors = error.response.data.errors;
					}
				}).finally(() => {
					this.loading = false;
				})
			},
			confirmDelete(id){
				Confirmation.swalDelete().then(response => {
					if(response.isConfirmed === true){
						this.deleteUser(id);
					}
				})
			},
			deleteUser(id) {
				User.delete(id)
					.then(() => {
						this.users.splice(this.users.map(user => user.id).indexOf(id),1);
					})
			},
		},
	}
</script>

<style>
	
</style>